import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
// import SideNav from "../../components/commonComponents/Sidebar/SideNav";
import TableauDash from "../../components/commonComponents/TableauDashboard/TableauDash";
import { StickyTopRowStack, StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import StoreFilter from "../../components/commonComponents/Filters/StoreFilter";
import DateRangeFilter from "../../components/commonComponents/Filters/DateRangeFilter";
// ,
import { checkWorkbookFilters, filterRangeValue } from "../../api_calls/TableauVisuals";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie, checkWorkSpaceFromCookies } from "../../api_calls/userManagement";
import { embeddableFilterEnabled, findEmbeddableId, findStoreIds, resetCampaignsClipsPictureReduxState } from "../../api_calls/utils";
import ActionButton from "../../components/commonComponents/Buttons/ActionButton";
import { useDispatch, useSelector } from "react-redux";
import {
  dbFormatDate,
  formatToStandardDate,
  resetBrandReportView,
  standardFormatToday,
  storeListOptionsForTableauFilter,
  yesterdayDate,
} from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import DateRangeInputFields from "../../components/commonComponents/Filters/DateRangeInputFields";
import { deleteItems } from "../../Store/actions";
import { loadStores } from "../../api_calls/campaigns";
import { setBatchLoadingStatus } from "../../api_calls/requestConfig";

const Overview = () => {
  const [userInfo, setUserInfo] = React.useState({});
  const userStateDate = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const { date_range_start_date, date_range_end_date } = userStateDate;
  const [filterEnabled, setFilterEnabled] = React.useState(false);


  const { minSelectableDate, maxSelectableDate } = React.useMemo(() => {
    const today = standardFormatToday();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const start = date_range_start_date
      ? new Date(date_range_start_date)
      : new Date("2023-02-07");

    const end = date_range_end_date
      ? new Date(date_range_end_date)
      : dbFormatDate(yesterday);

    return {
      minSelectableDate: start,
      maxSelectableDate: end,
    };
  }, [date_range_start_date, date_range_end_date]);

  const dashboardVariables = () => {
    let overviewDashboardVariables = {};

    if (typeof userStateDate.embedded_landing_page_stores !== "undefined" && typeof userStateDate.embedded_landing_page_stores.store_ids !== "undefined" && userStateDate.embedded_landing_page_stores.store_ids.length !== 0) {
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Stores: userStateDate.embedded_landing_page_stores.store_ids,
      }

    }

    if (typeof userStateDate.embedded_landing_page_date !== "undefined") {
      const endDate = new Date(userStateDate?.embedded_landing_page_date.to);
      endDate.setDate(endDate.getDate() + 1); // add one day to
      overviewDashboardVariables = {
        ...overviewDashboardVariables,
        Date: {
          from: userStateDate?.embedded_landing_page_date.from,
          to: endDate
        },
      }
    }

    return overviewDashboardVariables;
  }

  React.useEffect(() => {
    resetBrandReportView();
    resetCampaignsClipsPictureReduxState();
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    // check if filters are enabled
    const overviewFiltersStatus = embeddableFilterEnabled("overview", "landing_page_overview_filter");

    setFilterEnabled(overviewFiltersStatus);
    if (overviewFiltersStatus === false) {
      loadStores("overview");
    }
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);

  return typeof userInfo.root_company_id !== "undefined" ? (
    <StyledMainBox component="main">
      {/* ------------- filters -------------- */}
      {
        filterEnabled && (
          <StickyTopRowStack direction={"row"} spacing={1} sx={{ mr: 0 }}>
            {/* ------- stores filter ----------- */}
            <Box sx={{ width: 250 }}>
              <StoreFilter
                usedFor={"overview"}
                reduxKeywordToSaveValue={"embedded_landing_page_stores"} />
              {/* <StoreFilter usedFor={"overview"} fieldName="Id Store" vizId={"generalKpiViz"} /> */}
            </Box>
            {/* ------------ day timestamp filter ------------ */}
            {typeof userStateDate.date_range_start_date !== "undefined" && (
              <Box>
                <DateRangeInputFields
                  minSelectableDate={minSelectableDate}
                  maxSelectableDate={maxSelectableDate}
                  reduxKeywordToSaveValue={"embedded_landing_page_date"}
                />
              </Box>
            )}
          </StickyTopRowStack>
        )
      }

      {/* -------- tableau dashboard -------- */}
      <Box height={1} />
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" && typeof userStateDate.stores_list !== "undefined" && (
          <Dashboard
            embedDashboardId={findEmbeddableId("overview", "landing_page_overview")}
            variables={dashboardVariables()}
            filterConfig={{
              "number_root": userInfo.root_company_id.toString(),
            }} />
        )}
      </Grid>
    </StyledMainBox>
  ) : (
    <></>
  );
};

export default AccessControl(Overview, ["overview_can_view"], [], ["overview"]);
